import * as Yup from 'yup';
import * as moment from 'moment';

export function setInitialValuesGlobalFee(pageData) {
  return {
    sellerFee: pageData?.sellerFee?.toFixed(1) ?? '',
    buyerFee: pageData?.buyerFee?.toFixed(1) ?? '',
    brokerFee: pageData?.brokerFee?.toFixed(1) ?? '',
    ptPlusSellerFee: pageData?.ptPlusSellerFee?.toFixed(1) ?? '',
    ptPlusBuyerFee: pageData?.ptPlusBuyerFee?.toFixed(1) ?? '',
    supplierTermDelivery: pageData?.supplierTermDelivery ?? '',
    supplierTermPickup: pageData?.supplierTermPickup ?? '',
    comments: pageData?.comments || ''
  };
}

export const GLOBAL_FEE_VALIDATION_SCHEMA = () => {
  let schemaAttributes = {
    sellerFee: Yup.string().trim().required('Fee is required.'),
    buyerFee: Yup.string().trim().required('Fee is required.'),
    brokerFee: Yup.string().trim().required('Fee is required.'),
    ptPlusSellerFee: Yup.string().trim().required('Fee is required.'),
    ptPlusBuyerFee: Yup.string().trim().required('Fee is required.'),
    supplierTermDelivery: Yup.string().trim().required('Delivery days is required.'),
    supplierTermPickup: Yup.string().trim().required('Pickup days is required.'),
  }
  return Yup.object().shape(schemaAttributes);
}

export function setInitialValuesSupplierFee() {
  return {
    company: '',
    companyType: '',
    address: '',
    city: '',
    contact: '',
    paymentTerms: '',
    deliveryTermDiscount: '',
    collectionTerms: '',
    pickupTermDiscount: '',
    sellerFee: '',
    buyerFee: '',
    brokerFee: '',
    comments: ''
  };
}

export const SUPPLIER_FEE_VALIDATION_SCHEMA = () => {
  let schemaAttributes = {
    // paymentTerms: Yup.string().trim().required('Payment terms is required.'),
    // collectionTerms: Yup.string().trim().required('Collection terms is required.'),
    // buyerFee: Yup.string().trim().when('companyType', {
    //   is: (val) => val === 'BUYER' || val === 'BUYSELL',
    //   then: (schema) => schema.required('Buyer Fee is required.'),
    //   otherwise: (schema) => schema.notRequired()
    // }),
    // sellerFee: Yup.string().trim().when('companyType', {
    //   is: (val) => val === 'SELLER' || val === 'BUYSELL',
    //   then: (schema) => schema.required('Seller Fee is required.'),
    //   otherwise: (schema) => schema.notRequired()
    // }),
    // brokerFee: Yup.string().trim().when('companyType', {
    //   is: (val) => val === 'BROKER',
    //   then: (schema) => schema.required('Broker Fee is required.'),
    //   otherwise: (schema) => schema.notRequired()
    // }),
  }
  return Yup.object().shape(schemaAttributes);
}
